import React, { useEffect, useState } from 'react';

import { Alert } from 'antd';

import BillingInfo from '@components/BillingInfo/BillingInfo';
import ContactDropdown from '@components/ContactDropdown/ContactDropdown';
import Select from '@components/Gui/NwForm/CustomSelect';
import { getTransactionContactBillingInfo } from '@components/Project/ProjectTransactions/Transactions/TransactionCreateFormUtils';

import NwDrawer from '../NwDrawer';

const ContactWithBillingInfo = ({ value, onChange, contacts, billingInfos, onBlur, fullSelector, activeTypes }) => {
    const [contactBillingInfos, setContactBillingInfos] = useState(billingInfos);
    const [selectedContact, setSelectedContact] = useState(value ? value.ContactID : null);
    const [billingInfoDrawer, setBillingInfoDrawer] = useState(false);
    const [loadingBillingInfo, setLoadingBillingInfo] = useState(false);

    const contactDropdownActiveTypes =
        activeTypes && Array.isArray(activeTypes) ? [...activeTypes] : ['cli', 'age', 'srv'];

    const getSelectedBillingInfo = () => {
        if (!value || !contactBillingInfos) {
            return null;
        }
        return contactBillingInfos.find((item) => item.ID === value.ContactBillingInfoID);
    };

    const getDefaultBillingInfo = () => {
        return contactBillingInfos.find((item) => item.isDefault);
    };

    const [selectedBillingInfo, setSelectedBillingInfo] = useState(getSelectedBillingInfo());

    useEffect(() => {
        if (!selectedContact) {
            onChange({
                ContactID: null,
                ContactBillingInfoID: null,
            });
            return;
        }
        const fetchBillingInfo = async (contactID) => {
            setLoadingBillingInfo(true);
            const fetchedBillingInfos = await getTransactionContactBillingInfo(contactID);
            setContactBillingInfos(fetchedBillingInfos);
            setLoadingBillingInfo(false);
        };
        if (!value || (selectedContact && selectedContact !== value.ContactID)) {
            onChange({
                ...value,
                ContactID: selectedContact,
            });
            fetchBillingInfo(selectedContact);
        }
    }, [selectedContact]);

    useEffect(() => {
        if (contactBillingInfos) {
            setSelectedBillingInfo(getDefaultBillingInfo());
        }
    }, [contactBillingInfos]);

    useEffect(() => {
        if (selectedBillingInfo) {
            onChange({
                ...value,
                ContactBillingInfoID: selectedBillingInfo.ID,
            });
        }
    }, [selectedBillingInfo]);

    const onChangeContact = (event) => {
        //CLEAR BILLING INFO
        setSelectedBillingInfo(null);

        //LOAD BILLING INFO FOR SELECTED CLIENT AND PUT IN STATE
        setSelectedContact(event);
    };

    const handleSelectBillingInfo = (billingInfo) => {
        setSelectedBillingInfo(billingInfo);
        setBillingInfoDrawer(false);
        onBlur();
    };

    return (
        <>
            <div>
                {fullSelector ? (
                    <ContactDropdown
                        //value={value.ContactID}
                        value={selectedContact}
                        activeTypes={contactDropdownActiveTypes}
                        //activableTypes={['cli', 'srv']}
                        onChange={onChangeContact}
                        onBlur={onBlur}
                        topListContacts={contacts}
                    />
                ) : contacts.length > 1 ? (
                    <Select
                        //value={value.ContactID}
                        value={selectedContact}
                        disabled={contacts.length === 1}
                        options={contacts.map((el) => {
                            return { key: el.ID, value: el.ID, label: el.Name };
                        })}
                        onBlur={onBlur}
                        onChange={onChangeContact}
                    />
                ) : (
                    <h3>{contacts[0].Name}</h3>
                )}
                {selectedBillingInfo ? (
                    <BillingInfo
                        data={selectedBillingInfo}
                        editable={contactBillingInfos && contactBillingInfos.length > 1}
                        buttonLabel="change billing profile"
                        onClick={() => setBillingInfoDrawer(true)}
                    />
                ) : loadingBillingInfo ? (
                    <small>loading billing info</small>
                ) : (
                    selectedContact && <small>no billing info</small>
                )}
            </div>
            {billingInfoDrawer && (
                <NwDrawer title="Select billing info" onClose={() => setBillingInfoDrawer(false)} width="40rem">
                    {contactBillingInfos.map((billingInfo) => (
                        <BillingInfo
                            key={billingInfo.ID}
                            data={billingInfo}
                            editable={true}
                            buttonLabel="select"
                            onClick={() => handleSelectBillingInfo(billingInfo)}
                            extended
                        />
                    ))}
                </NwDrawer>
            )}
        </>
    );
};

export default ContactWithBillingInfo;
